import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import SidebarMenu from "./SidebarMenu";
import StoreBrandLogo from "../StoreBrandLogo";
import PATH_URL from "../../routers/path";
import "./sidebarMenu.css";

const Sidebar = ({ userProfile, storeSetting, isAreaExpanded, onCloseArea }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const permissions = userProfile?.permissions || [];

  useEffect(() => {
    onCloseArea?.();
  }, [onCloseArea, pathname]);

  return (
    <aside
      className={`navbar navbar-vertical navbar-left navbar-expand-lg dashboard-sidebar ${isAreaExpanded ? "is-mobile-open" : ""}`}
      aria-label="Navigasi utama">
      <div className="container-fluid">
        <div className="sidebar-drawer-header d-lg-none">
          <Link to={PATH_URL.DASHBOARD} className="sidebar-drawer-brand" onClick={onCloseArea}>
            <StoreBrandLogo storeSetting={storeSetting} />
          </Link>
          <button
            type="button"
            className="d-none sidebar-drawer-close"
            onClick={onCloseArea}
            aria-label="Tutup navigasi">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="navbar-brand navbar-brand-autodark d-none d-lg-block text-center p-0 pb-1">
          <Link to={PATH_URL.DASHBOARD} aria-label="Beranda AKAS">
            <StoreBrandLogo storeSetting={storeSetting} />
          </Link>
        </div>

        <div
          className={`${isAreaExpanded ? "collapse navbar-collapse show" : "collapse navbar-collapse"}`}
          id="sidebar-menu">
          <SidebarMenu pathname={pathname} permissions={permissions} userProfile={userProfile} />
        </div>
      </div>
    </aside>
  );
};

const mapStateToProps = (state) => ({
  storeSetting: state?.stores?.setting,
});

export default connect(mapStateToProps)(Sidebar);
